var classes = [{'id': 'system', 'path': '/api/library/common/class.system'},
    {'id': 'game_framework_master_game',
    'path': '/code/uniginescript/scripts/game_framework/library/system_script/class.mastergame'},
    {'id': 'game_framework_entitydata',
    'path': '/code/uniginescript/scripts/game_framework/library/world_script/class.entitydata'},
    {'id': 'game_framework_leveldata',
    'path': '/code/uniginescript/scripts/game_framework/library/world_script/class.leveldata'},
    {'id': 'game_framework_gamedata',
    'path': '/code/uniginescript/scripts/game_framework/library/world_script/class.gamedata'},
    {'id': 'game_framework_game',
    'path': '/code/uniginescript/scripts/game_framework/library/world_script/runtime/class.game'},
    {'id': 'game_framework_level',
    'path': '/code/uniginescript/scripts/game_framework/library/world_script/runtime/class.level'},
    {'id': 'game_framework_entity',
    'path': '/code/uniginescript/scripts/game_framework/library/world_script/runtime/class.entity'},
    {'id': 'game_framework_entitypool',
    'path': '/code/uniginescript/scripts/game_framework/library/world_script/runtime/class.entitypool'},
    {'id': 'game_framework_logicmodules',
    'path': '/code/uniginescript/scripts/game_framework/library/world_script/runtime/class.logicmodules'},
    {'id': 'game_framework_field',
    'path': '/code/uniginescript/scripts/game_framework/library/world_script/runtime/class.field'},
    {'id': 'game_framework_fields',
    'path': '/code/uniginescript/scripts/game_framework/library/world_script/runtime/class.fields'},
    {'id': 'game_framework_scheduler',
    'path': '/code/uniginescript/scripts/game_framework/library/world_script/runtime/class.scheduler'},
    {'id': 'game_framework_frequencygroup',
    'path': '/code/uniginescript/scripts/game_framework/library/world_script/runtime/class.frequencygroup'},
    {'id': 'game_framework_eventsystem',
    'path': '/code/uniginescript/scripts/game_framework/library/world_script/runtime/class.eventsystem'},
    {'id': 'game_framework_gameevent',
    'path': '/code/uniginescript/scripts/game_framework/library/world_script/runtime/class.gameevent'},
    {'id': 'game_framework_gamecallback',
    'path': '/code/uniginescript/scripts/game_framework/library/world_script/runtime/class.gamecallback'},
    {'id': 'arraymap', 'path': '/api/library/containers/arraymap/class.arraymap'},
    {'id': 'arraymap_iterator',
    'path': '/api/library/containers/arraymap/class.arraymap.iterator'},
    {'id': 'arrayvector', 'path': '/api/library/containers/class.arrayvector'},
    {'id': 'bimap', 'path': '/api/library/containers/class.bimap'},
    {'id': 'hashmap', 'path': '/api/library/containers/class.hashmap'},
    {'id': 'hashset', 'path': '/api/library/containers/class.hashset'},
    {'id': 'map', 'path': '/api/library/containers/class.map'},
    {'id': 'pair', 'path': '/api/library/containers/class.pair'},
    {'id': 'set', 'path': '/api/library/containers/class.set'},
    {'id': 'tree', 'path': '/api/library/containers/tree/class.tree'},
    {'id': 'tree_1_1constiterator',
    'path': '/api/library/containers/tree/class.tree.1.1constiterator'},
    {'id': 'tree_1_1iterator',
    'path': '/api/library/containers/tree/class.tree.1.1iterator'},
    {'id': 'vector', 'path': '/api/library/containers/vector/class.vector'},
    {'id': 'vector_1_1constiterator',
    'path': '/api/library/containers/vector/class.vector.1.1constiterator'},
    {'id': 'vector_1_1iterator',
    'path': '/api/library/containers/vector/class.vector.1.1iterator'},
    {'id': 'vectorstack',
    'path': '/api/library/containers/vector/class.vectorstack'},
    {'id': 'async', 'path': '/api/library/common/class.async'},
    {'id': 'atomiclock', 'path': '/api/library/common/class.atomiclock'},
    {'id': 'scopedlock', 'path': '/api/library/common/class.scopedlock'},
    {'id': 'scopedreaderlock',
    'path': '/api/library/common/class.scopedreaderlock'},
    {'id': 'scopedreentrantlock',
    'path': '/api/library/common/class.scopedreentrantlock'},
    {'id': 'scopedwriterlock',
    'path': '/api/library/common/class.scopedwriterlock'},
    {'id': 'atomic', 'path': '/api/library/common/class.atomic'},
    {'id': 'backoffspinner', 'path': '/api/library/common/class.backoffspinner'},
    {'id': 'mutex', 'path': '/api/library/common/class.mutex'},
    {'id': 'reentrantmutex', 'path': '/api/library/common/class.reentrantmutex'},
    {'id': 'rwmutex', 'path': '/api/library/common/class.rwmutex'},
    {'id': 'blob', 'path': '/api/library/common/class.blob'},
    {'id': 'callbackbase',
    'path': '/api/library/common/callbacks/class.callbackbase'},
    {'id': 'callbackbase1',
    'path': '/api/library/common/callbacks/class.callbackbase1'},
    {'id': 'callbackbase2',
    'path': '/api/library/common/callbacks/class.callbackbase2'},
    {'id': 'callbackbase3',
    'path': '/api/library/common/callbacks/class.callbackbase3'},
    {'id': 'callbackbase4',
    'path': '/api/library/common/callbacks/class.callbackbase4'},
    {'id': 'callbackbase5',
    'path': '/api/library/common/callbacks/class.callbackbase5'},
    {'id': 'signal', 'path': '/api/library/common/class.signal'},
    {'id': 'checksum', 'path': '/api/library/common/class.checksum'},
    {'id': 'crc32', 'path': '/api/library/common/class.crc32'},
    {'id': 'md5', 'path': '/api/library/common/class.md5'},
    {'id': 'sha1', 'path': '/api/library/common/class.sha1'},
    {'id': 'sha256', 'path': '/api/library/common/class.sha256'},
    {'id': 'compress', 'path': '/api/library/common/class.compress'},
    {'id': 'consolevariablefloat',
    'path': '/api/library/common/class.consolevariablefloat'},
    {'id': 'consolevariableint',
    'path': '/api/library/common/class.consolevariableint'},
    {'id': 'consolevariablestring',
    'path': '/api/library/common/class.consolevariablestring'},
    {'id': 'curve2d', 'path': '/api/library/common/class.curve2d'},
    {'id': 'expression', 'path': '/api/library/common/class.expression'},
    {'id': 'externclass', 'path': '/api/library/common/class.externclass'},
    {'id': 'functionbase', 'path': '/api/library/common/class.functionbase'},
    {'id': 'hash', 'path': '/api/library/common/class.hash'},
    {'id': 'hasher', 'path': '/api/library/common/class.hasher'},
    {'id': 'import_import', 'path': '/api/library/common/import/class.import'},
    {'id': 'import_importer',
    'path': '/api/library/common/import/class.importer'},
    {'id': 'import_importprocessor',
    'path': '/api/library/common/import/class.importprocessor'},
    {'id': 'import_importscene',
    'path': '/api/library/common/import/class.importscene'},
    {'id': 'fbximport_importgeometry',
    'path': '/api/library/plugins/fbximport/class.importgeometry'},
    {'id': 'fbximport_importsurface',
    'path': '/api/library/plugins/fbximport/class.importsurface'},
    {'id': 'export', 'path': '/api/library/common/export/class.export'},
    {'id': 'exporter', 'path': '/api/library/common/export/class.exporter'},
    {'id': 'image', 'path': '/api/library/common/class.image'},
    {'id': 'imageconverter', 'path': '/api/library/common/class.imageconverter'},
    {'id': 'interpreter', 'path': '/api/library/common/class.interpreter'},
    {'id': 'json', 'path': '/api/library/common/class.json'},
    {'id': 'log', 'path': '/api/library/common/class.log'},
    {'id': 'editorlogic', 'path': '/api/library/common/logic/class.editorlogic'},
    {'id': 'systemlogic', 'path': '/api/library/common/logic/class.systemlogic'},
    {'id': 'worldlogic', 'path': '/api/library/common/logic/class.worldlogic'},
    {'id': 'componentbase',
    'path': '/api/library/common/logic/component_system/cpp/class.componentbase'},
    {'id': 'componentsystem',
    'path': '/api/library/common/logic/component_system/cpp/class.componentsystem'},
    {'id': 'componentvariable',
    'path': '/api/library/common/logic/component_system/cpp/class.componentvariable'},
    {'id': 'cs_component',
    'path': '/api/library/common/logic/component_system/cs/class.component'},
    {'id': 'cs_componentsystem',
    'path': '/api/library/common/logic/component_system/cs/class.componentsystem'},
    {'id': 'cs_assetlink',
    'path': '/api/library/common/logic/component_system/cs/class.assetlink'},
    {'id': 'cs_assetlinknode',
    'path': '/api/library/common/logic/component_system/cs/class.assetlinknode'},
    {'id': 'os', 'path': '/api/library/common/class.os'},
    {'id': 'palette', 'path': '/api/library/common/class.palette'},
    {'id': 'path', 'path': '/api/library/common/class.path'},
    {'id': 'plugin', 'path': '/api/library/common/class.plugin'},
    {'id': 'property', 'path': '/api/library/common/class.property'},
    {'id': 'propertyparameter',
    'path': '/api/library/common/class.propertyparameter'},
    {'id': 'ptr', 'path': '/api/library/common/class.ptr'},
    {'id': 'reflection', 'path': '/api/library/common/class.reflection'},
    {'id': 'regexp', 'path': '/api/library/common/class.regexp'},
    {'id': 'resource', 'path': '/api/library/common/class.resource'},
    {'id': 'stream', 'path': '/api/library/common/class.stream'},
    {'id': 'string', 'path': '/api/library/common/class.string'},
    {'id': 'stringarray', 'path': '/api/library/common/class.stringarray'},
    {'id': 'stringptr', 'path': '/api/library/common/class.stringptr'},
    {'id': 'stringstack', 'path': '/api/library/common/class.stringstack'},
    {'id': 'system', 'path': '/api/library/common/class.system'},
    {'id': 'thread', 'path': '/api/library/common/class.thread'},
    {'id': 'time', 'path': '/api/library/common/class.time'},
    {'id': 'typeinfo', 'path': '/api/library/common/class.typeinfo'},
    {'id': 'ulonarg', 'path': '/api/library/common/class.ulonarg'},
    {'id': 'ulonvalue', 'path': '/api/library/common/class.ulonvalue'},
    {'id': 'ulonnode', 'path': '/api/library/common/class.ulonnode'},
    {'id': 'unigine_namespace',
    'path': '/api/library/common/class.unigine.namespace'},
    {'id': 'utils', 'path': '/api/library/common/class.utils'},
    {'id': 'xml', 'path': '/api/library/common/class.xml'},
    {'id': 'variable', 'path': '/api/library/common/class.variable'},
    {'id': 'controls', 'path': '/api/library/controls/class.controls'},
    {'id': 'controlsapp', 'path': '/api/library/controls/class.controlsapp'},
    {'id': 'controlsdummy', 'path': '/api/library/controls/class.controlsdummy'},
    {'id': 'controlsjoystick',
    'path': '/api/library/controls/class.controlsjoystick'},
    {'id': 'controlssixaxis',
    'path': '/api/library/controls/class.controlssixaxis'},
    {'id': 'controlsxpad360',
    'path': '/api/library/controls/class.controlsxpad360'},
    {'id': 'input', 'path': '/api/library/controls/class.input'},
    {'id': 'inputgamepad', 'path': '/api/library/controls/class.inputgamepad'},
    {'id': 'app', 'path': '/api/library/engine/class.app'},
    {'id': 'bootconfig', 'path': '/api/library/engine/class.bootconfig'},
    {'id': 'customapp', 'path': '/api/library/engine/class.customapp'},
    {'id': 'config', 'path': '/api/library/engine/class.config'},
    {'id': 'console', 'path': '/api/library/engine/class.console'},
    {'id': 'editor', 'path': '/api/library/engine/class.editor'},
    {'id': 'engine', 'path': '/api/library/engine/class.engine'},
    {'id': 'engineptr', 'path': '/api/library/engine/class.engineptr'},
    {'id': 'enginesystem', 'path': '/api/library/engine/class.enginesystem'},
    {'id': 'engineplugins', 'path': '/api/library/engine/class.engineplugins'},
    {'id': 'game', 'path': '/api/library/engine/class.game'},
    {'id': 'gameintersection',
    'path': '/api/library/engine/class.gameintersection'},
    {'id': 'loadingscreen', 'path': '/api/library/engine/class.loadingscreen'},
    {'id': 'memory', 'path': '/api/library/engine/class.memory'},
    {'id': 'profiler', 'path': '/api/library/engine/class.profiler'},
    {'id': 'properties', 'path': '/api/library/engine/class.properties'},
    {'id': 'sound', 'path': '/api/library/engine/class.sound'},
    {'id': 'sounds', 'path': '/api/library/engine/class.sounds'},
    {'id': 'systemdialog', 'path': '/api/library/engine/class.systemdialog'},
    {'id': 'systeminfo', 'path': '/api/library/engine/class.systeminfo'},
    {'id': 'userconfig', 'path': '/api/library/engine/class.userconfig'},
    {'id': 'visualizer', 'path': '/api/library/engine/class.visualizer'},
    {'id': 'world', 'path': '/api/library/engine/class.world'},
    {'id': 'dir', 'path': '/api/library/filesystem/class.dir'},
    {'id': 'file', 'path': '/api/library/filesystem/class.file'},
    {'id': 'filesystem', 'path': '/api/library/filesystem/class.filesystem'},
    {'id': 'filesystemassets',
    'path': '/api/library/filesystem/class.filesystemassets'},
    {'id': 'filesystemmount',
    'path': '/api/library/filesystem/class.filesystemmount'},
    {'id': 'asyncqueue', 'path': '/api/library/filesystem/class.asyncqueue'},
    {'id': 'package', 'path': '/api/library/filesystem/class.package'},
    {'id': 'packageung', 'path': '/api/library/filesystem/class.packageung'},
    {'id': 'uguid', 'path': '/api/library/filesystem/class.uguid'},
    {'id': 'gui', 'path': '/api/library/gui/class.gui'},
    {'id': 'userinterface', 'path': '/api/library/gui/class.userinterface'},
    {'id': 'widget', 'path': '/api/library/gui/class.widget'},
    {'id': 'widgetbutton', 'path': '/api/library/gui/class.widgetbutton'},
    {'id': 'widgetcanvas', 'path': '/api/library/gui/class.widgetcanvas'},
    {'id': 'widgetcheckbox', 'path': '/api/library/gui/class.widgetcheckbox'},
    {'id': 'widgetcombobox', 'path': '/api/library/gui/class.widgetcombobox'},
    {'id': 'widgetdialog', 'path': '/api/library/gui/class.widgetdialog'},
    {'id': 'widgetdialogcolor',
    'path': '/api/library/gui/class.widgetdialogcolor'},
    {'id': 'widgetdialogfile', 'path': '/api/library/gui/class.widgetdialogfile'},
    {'id': 'widgetdialogimage',
    'path': '/api/library/gui/class.widgetdialogimage'},
    {'id': 'widgetdialogmessage',
    'path': '/api/library/gui/class.widgetdialogmessage'},
    {'id': 'widgeteditline', 'path': '/api/library/gui/class.widgeteditline'},
    {'id': 'widgetedittext', 'path': '/api/library/gui/class.widgetedittext'},
    {'id': 'widgetexternbase', 'path': '/api/library/gui/class.widgetexternbase'},
    {'id': 'widgetextern', 'path': '/api/library/gui/class.widgetextern'},
    {'id': 'widgetgridbox', 'path': '/api/library/gui/class.widgetgridbox'},
    {'id': 'widgetgroupbox', 'path': '/api/library/gui/class.widgetgroupbox'},
    {'id': 'widgethbox', 'path': '/api/library/gui/class.widgethbox'},
    {'id': 'widgethpaned', 'path': '/api/library/gui/class.widgethpaned'},
    {'id': 'widgeticon', 'path': '/api/library/gui/class.widgeticon'},
    {'id': 'widgetlabel', 'path': '/api/library/gui/class.widgetlabel'},
    {'id': 'widgetlistbox', 'path': '/api/library/gui/class.widgetlistbox'},
    {'id': 'widgetmanipulator',
    'path': '/api/library/gui/class.widgetmanipulator'},
    {'id': 'widgetmanipulatorrotator',
    'path': '/api/library/gui/class.widgetmanipulatorrotator'},
    {'id': 'widgetmanipulatorscaler',
    'path': '/api/library/gui/class.widgetmanipulatorscaler'},
    {'id': 'widgetmanipulatortranslator',
    'path': '/api/library/gui/class.widgetmanipulatortranslator'},
    {'id': 'widgetmenubar', 'path': '/api/library/gui/class.widgetmenubar'},
    {'id': 'widgetmenubox', 'path': '/api/library/gui/class.widgetmenubox'},
    {'id': 'widgetscroll', 'path': '/api/library/gui/class.widgetscroll'},
    {'id': 'widgetscrollbox', 'path': '/api/library/gui/class.widgetscrollbox'},
    {'id': 'widgetslider', 'path': '/api/library/gui/class.widgetslider'},
    {'id': 'widgetspacer', 'path': '/api/library/gui/class.widgetspacer'},
    {'id': 'widgetspinbox', 'path': '/api/library/gui/class.widgetspinbox'},
    {'id': 'widgetspinboxdouble',
    'path': '/api/library/gui/class.widgetspinboxdouble'},
    {'id': 'widgetsprite', 'path': '/api/library/gui/class.widgetsprite'},
    {'id': 'widgetspritenode', 'path': '/api/library/gui/class.widgetspritenode'},
    {'id': 'widgetspriteshader',
    'path': '/api/library/gui/class.widgetspriteshader'},
    {'id': 'widgetspritevideo',
    'path': '/api/library/gui/class.widgetspritevideo'},
    {'id': 'widgetspriteviewport',
    'path': '/api/library/gui/class.widgetspriteviewport'},
    {'id': 'widgettabbox', 'path': '/api/library/gui/class.widgettabbox'},
    {'id': 'widgettreebox', 'path': '/api/library/gui/class.widgettreebox'},
    {'id': 'widgetvbox', 'path': '/api/library/gui/class.widgetvbox'},
    {'id': 'widgetvpaned', 'path': '/api/library/gui/class.widgetvpaned'},
    {'id': 'widgetwindow', 'path': '/api/library/gui/class.widgetwindow'},
    {'id': 'math_cs_geometry', 'path': '/api/library/math/cs/geometry'},
    {'id': 'boundbox', 'path': '/api/library/math/bounds/class.boundbox'},
    {'id': 'boundfrustum', 'path': '/api/library/math/bounds/class.boundfrustum'},
    {'id': 'boundsphere', 'path': '/api/library/math/bounds/class.boundsphere'},
    {'id': 'worldboundbox',
    'path': '/api/library/math/bounds/class.worldboundbox'},
    {'id': 'worldboundfrustum',
    'path': '/api/library/math/bounds/class.worldboundfrustum'},
    {'id': 'worldboundsphere',
    'path': '/api/library/math/bounds/class.worldboundsphere'},
    {'id': 'math_geometry', 'path': '/api/library/math/class.geometry'},
    {'id': 'bits', 'path': '/api/library/math/class.bits'},
    {'id': 'bitstream', 'path': '/api/library/math/class.bitstream'},
    {'id': 'bvec4', 'path': '/api/library/math/class.bvec4'},
    {'id': 'concave', 'path': '/api/library/math/class.concave'},
    {'id': 'concaveconvexcompare',
    'path': '/api/library/math/class.concaveconvexcompare'},
    {'id': 'convex', 'path': '/api/library/math/class.convex'},
    {'id': 'dmat4', 'path': '/api/library/math/class.dmat4'},
    {'id': 'dvec2', 'path': '/api/library/math/class.dvec2'},
    {'id': 'dvec3', 'path': '/api/library/math/class.dvec3'},
    {'id': 'dvec4', 'path': '/api/library/math/class.dvec4'},
    {'id': 'half', 'path': '/api/library/math/class.half'},
    {'id': 'hvec2', 'path': '/api/library/math/class.hvec2'},
    {'id': 'hvec3', 'path': '/api/library/math/class.hvec3'},
    {'id': 'hvec4', 'path': '/api/library/math/class.hvec4'},
    {'id': 'ivec2', 'path': '/api/library/math/class.ivec2'},
    {'id': 'ivec3', 'path': '/api/library/math/class.ivec3'},
    {'id': 'ivec4', 'path': '/api/library/math/class.ivec4'},
    {'id': 'mat2', 'path': '/api/library/math/class.mat2'},
    {'id': 'mat3', 'path': '/api/library/math/class.mat3'},
    {'id': 'mat4', 'path': '/api/library/math/class.mat4'},
    {'id': 'noise', 'path': '/api/library/math/class.noise'},
    {'id': 'polygon', 'path': '/api/library/math/class.polygon'},
    {'id': 'quat', 'path': '/api/library/math/class.quat'},
    {'id': 'random', 'path': '/api/library/math/class.random'},
    {'id': 'shbasis', 'path': '/api/library/math/class.shbasis'},
    {'id': 'svec4', 'path': '/api/library/math/class.svec4'},
    {'id': 'vec2', 'path': '/api/library/math/class.vec2'},
    {'id': 'vec3', 'path': '/api/library/math/class.vec3'},
    {'id': 'vec4', 'path': '/api/library/math/class.vec4'},
    {'id': 'node', 'path': '/api/library/nodes/class.node'},
    {'id': 'nodedummy', 'path': '/api/library/nodes/class.nodedummy'},
    {'id': 'nodeextern', 'path': '/api/library/nodes/class.nodeextern'},
    {'id': 'nodeexternbase', 'path': '/api/library/nodes/class.nodeexternbase'},
    {'id': 'nodelayer', 'path': '/api/library/nodes/class.nodelayer'},
    {'id': 'nodepivot', 'path': '/api/library/nodes/class.nodepivot'},
    {'id': 'nodereference', 'path': '/api/library/nodes/class.nodereference'},
    {'id': 'nodetrigger', 'path': '/api/library/nodes/class.nodetrigger'},
    {'id': 'decal',
    'path': '/api/library/decals/class.decal'},
    {'id': 'decalmesh',
    'path': '/api/library/decals/class.decalmesh'},
    {'id': 'decalortho',
    'path': '/api/library/decals/class.decalortho'},
    {'id': 'decalproj',
    'path': '/api/library/decals/class.decalproj'},
    {'id': 'field', 'path': '/api/library/fields/class.field'},
    {'id': 'fieldanimation', 'path': '/api/library/fields/class.fieldanimation'},
    {'id': 'fieldheight', 'path': '/api/library/fields/class.fieldheight'},
    {'id': 'fieldshoreline', 'path': '/api/library/fields/class.fieldshoreline'},
    {'id': 'fieldspacer', 'path': '/api/library/fields/class.fieldspacer'},
    {'id': 'fieldweather', 'path': '/api/library/fields/class.fieldweather'},
    {'id': 'ellipsoid', 'path': '/api/library/geodetics/class.ellipsoid'},
    {'id': 'dataset', 'path': '/api/library/geodetics/class.dataset'},
    {'id': 'datasetrasterposresolver',
    'path': '/api/library/geodetics/class.datasetrasterposresolver'},
    {'id': 'datasetspatialreference',
    'path': '/api/library/geodetics/class.datasetspatialreference'},
    {'id': 'datasetcoordinatetransformer',
    'path': '/api/library/geodetics/class.datasetcoordinatetransformer'},
    {'id': 'geodeticpivot', 'path': '/api/library/geodetics/class.geodeticpivot'},
    {'id': 'geodeticstransformer',
    'path': '/api/library/geodetics/class.geodeticstransformer'},
    {'id': 'bakelighting', 'path': '/api/library/lights/class.bakelighting'},
    {'id': 'light', 'path': '/api/library/lights/class.light'},
    {'id': 'lightenvironmentprobe',
    'path': '/api/library/lights/class.lightenvironmentprobe'},
    {'id': 'lightvoxelprobe',
    'path': '/api/library/lights/class.lightvoxelprobe'},
    {'id': 'lightplanarprobe',
    'path': '/api/library/lights/class.lightplanarprobe'},
    {'id': 'lightomni', 'path': '/api/library/lights/class.lightomni'},
    {'id': 'lightproj', 'path': '/api/library/lights/class.lightproj'},
    {'id': 'lightworld', 'path': '/api/library/lights/class.lightworld'},
    {'id': 'lightlensflare', 'path': '/api/library/lights/class.lightlensflare'},
    {'id': 'object', 'path': '/api/library/objects/class.object'},
    {'id': 'objectbillboards',
    'path': '/api/library/objects/class.objectbillboards'},
    {'id': 'objectcloudlayer',
    'path': '/api/library/objects/class.objectcloudlayer'},
    {'id': 'objectdummy', 'path': '/api/library/objects/class.objectdummy'},
    {'id': 'objectdynamic', 'path': '/api/library/objects/class.objectdynamic'},
    {'id': 'objectextern', 'path': '/api/library/objects/class.objectextern'},
    {'id': 'objectexternbase',
    'path': '/api/library/objects/class.objectexternbase'},
    {'id': 'objectgrass', 'path': '/api/library/objects/class.objectgrass'},
    {'id': 'objectgui', 'path': '/api/library/objects/class.objectgui'},
    {'id': 'objectguimesh', 'path': '/api/library/objects/class.objectguimesh'},
    {'id': 'objectintersection',
    'path': '/api/library/objects/class.objectintersection'},
    {'id': 'objectintersectionnormal',
    'path': '/api/library/objects/class.objectintersectionnormal'},
    {'id': 'objectintersectiontexcoord',
    'path': '/api/library/objects/class.objectintersectiontexcoord'},
    {'id': 'objectlandscapeterrain',
    'path': '/api/library/objects/landscape_terrain/class.objectlandscapeterrain'},
    {'id': 'terraindetail',
    'path': '/api/library/objects/landscape_terrain/class.terraindetail'},
    {'id': 'terraindetailmask',
    'path': '/api/library/objects/landscape_terrain/class.terraindetailmask'},
    {'id': 'landscape',
    'path': '/api/library/objects/landscape_terrain/class.landscape'},
    {'id': 'landscapelayermap',
    'path': '/api/library/objects/landscape_terrain/class.landscapelayermap'},
    {'id': 'landscapemapfilecreator',
    'path': '/api/library/objects/landscape_terrain/class.landscapemapfilecreator'},
    {'id': 'landscapemapfilecompression',
    'path': '/api/library/objects/landscape_terrain/class.landscapemapfilecompression'},
    {'id': 'landscapemapfilesettings',
    'path': '/api/library/objects/landscape_terrain/class.landscapemapfilesettings'},
    {'id': 'landscapefetch',
    'path': '/api/library/objects/landscape_terrain/class.landscapefetch'},
    {'id': 'landscapeimages',
    'path': '/api/library/objects/landscape_terrain/class.landscapeimages'},
    {'id': 'landscapetextures',
    'path': '/api/library/objects/landscape_terrain/class.landscapetextures'},
    {'id': 'objectmeshstatic',
    'path': '/api/library/objects/class.objectmeshstatic'},
    {'id': 'objectmeshcluster',
    'path': '/api/library/objects/class.objectmeshcluster'},
    {'id': 'objectmeshclutter',
    'path': '/api/library/objects/class.objectmeshclutter'},
    {'id': 'objectmeshdynamic',
    'path': '/api/library/objects/class.objectmeshdynamic'},
    {'id': 'objectmeshskinned',
    'path': '/api/library/objects/class.objectmeshskinned'},
    {'id': 'objectmeshsplinecluster',
    'path': '/api/library/objects/class.objectmeshsplinecluster'},
    {'id': 'objectparticles',
    'path': '/api/library/objects/class.objectparticles'},
    {'id': 'particlemodifier',
    'path': '/api/library/objects/class.particlemodifier'},
    {'id': 'particlemodifierscalar',
    'path': '/api/library/objects/class.particlemodifierscalar'},
    {'id': 'particlemodifiervector',
    'path': '/api/library/objects/class.particlemodifiervector'},
    {'id': 'objectsky', 'path': '/api/library/objects/class.objectsky'},
    {'id': 'objectterrain', 'path': '/api/library/objects/class.objectterrain'},
    {'id': 'objectterrainglobal',
    'path': '/api/library/objects/class.objectterrainglobal'},
    {'id': 'terrainglobaldetail',
    'path': '/api/library/objects/class.terrainglobaldetail'},
    {'id': 'terraingloballod',
    'path': '/api/library/objects/class.terraingloballod'},
    {'id': 'terraingloballodheight',
    'path': '/api/library/objects/class.terraingloballodheight'},
    {'id': 'terraingloballods',
    'path': '/api/library/objects/class.terraingloballods'},
    {'id': 'tileset', 'path': '/api/library/objects/class.tileset'},
    {'id': 'tilesetfile', 'path': '/api/library/objects/class.tilesetfile'},
    {'id': 'objecttext', 'path': '/api/library/objects/class.objecttext'},
    {'id': 'objectvolumebox',
    'path': '/api/library/objects/class.objectvolumebox'},
    {'id': 'objectvolumeomni',
    'path': '/api/library/objects/class.objectvolumeomni'},
    {'id': 'objectvolumeproj',
    'path': '/api/library/objects/class.objectvolumeproj'},
    {'id': 'objectvolumesphere',
    'path': '/api/library/objects/class.objectvolumesphere'},
    {'id': 'objectwatermesh',
    'path': '/api/library/objects/class.objectwatermesh'},
    {'id': 'objectwaterglobal',
    'path': '/api/library/objects/class.objectwaterglobal'},
    {'id': 'player', 'path': '/api/library/players/class.player'},
    {'id': 'playeractor', 'path': '/api/library/players/class.playeractor'},
    {'id': 'playerdummy', 'path': '/api/library/players/class.playerdummy'},
    {'id': 'playerpersecutor',
    'path': '/api/library/players/class.playerpersecutor'},
    {'id': 'playerspectator',
    'path': '/api/library/players/class.playerspectator'},
    {'id': 'ambientsource', 'path': '/api/library/sounds/class.ambientsource'},
    {'id': 'soundreverb', 'path': '/api/library/sounds/class.soundreverb'},
    {'id': 'soundsource', 'path': '/api/library/sounds/class.soundsource'},
    {'id': 'worldcluster', 'path': '/api/library/worlds/class.worldcluster'},
    {'id': 'worldclutter', 'path': '/api/library/worlds/class.worldclutter'},
    {'id': 'worldexpression',
    'path': '/api/library/worlds/class.worldexpression'},
    {'id': 'worldexternbase',
    'path': '/api/library/worlds/class.worldexternbase'},
    {'id': 'worldextern', 'path': '/api/library/worlds/class.worldextern'},
    {'id': 'worldintersection',
    'path': '/api/library/worlds/class.worldintersection'},
    {'id': 'worldintersectionnormal',
    'path': '/api/library/worlds/class.worldintersectionnormal'},
    {'id': 'worldintersectiontexcoord',
    'path': '/api/library/worlds/class.worldintersectiontexcoord'},
    {'id': 'worldlayer', 'path': '/api/library/worlds/class.worldlayer'},
    {'id': 'worldoccluder', 'path': '/api/library/worlds/class.worldoccluder'},
    {'id': 'worldoccludermesh',
    'path': '/api/library/worlds/class.worldoccludermesh'},
    {'id': 'worldoccluderterrain',
    'path': '/api/library/worlds/class.worldoccluderterrain'},
    {'id': 'worldportal', 'path': '/api/library/worlds/class.worldportal'},
    {'id': 'worldsector', 'path': '/api/library/worlds/class.worldsector'},
    {'id': 'worldsplinegraph',
    'path': '/api/library/worlds/class.worldsplinegraph'},
    {'id': 'splinegraph', 'path': '/api/library/worlds/class.splinegraph'},
    {'id': 'splinepoint', 'path': '/api/library/worlds/class.splinepoint'},
    {'id': 'splinesegment', 'path': '/api/library/worlds/class.splinesegment'},
    {'id': 'worldswitcher', 'path': '/api/library/worlds/class.worldswitcher'},
    {'id': 'worldtransformbone',
    'path': '/api/library/worlds/class.worldtransformbone'},
    {'id': 'worldtransformpath',
    'path': '/api/library/worlds/class.worldtransformpath'},
    {'id': 'worldtrigger', 'path': '/api/library/worlds/class.worldtrigger'},
    {'id': 'socket', 'path': '/api/library/networking/class.socket'},
    {'id': 'navigation', 'path': '/api/library/pathfinding/class.navigation'},
    {'id': 'navigationmesh',
    'path': '/api/library/pathfinding/class.navigationmesh'},
    {'id': 'navigationsector',
    'path': '/api/library/pathfinding/class.navigationsector'},
    {'id': 'obstacle', 'path': '/api/library/pathfinding/class.obstacle'},
    {'id': 'obstaclebox', 'path': '/api/library/pathfinding/class.obstaclebox'},
    {'id': 'obstaclecapsule',
    'path': '/api/library/pathfinding/class.obstaclecapsule'},
    {'id': 'obstaclesphere',
    'path': '/api/library/pathfinding/class.obstaclesphere'},
    {'id': 'pathroute', 'path': '/api/library/pathfinding/class.pathroute'},
    {'id': 'pathrouteintersection',
    'path': '/api/library/pathfinding/class.pathrouteintersection'},
    {'id': 'contact', 'path': '/api/library/physics/class.contact'},
    {'id': 'shapecontact', 'path': '/api/library/physics/class.shapecontact'},
    {'id': 'physics', 'path': '/api/library/physics/class.physics'},
    {'id': 'physicsintersection',
    'path': '/api/library/physics/class.physicsintersection'},
    {'id': 'physicsintersectionnormal',
    'path': '/api/library/physics/class.physicsintersectionnormal'},
    {'id': 'body', 'path': '/api/library/physics/class.body'},
    {'id': 'bodycloth', 'path': '/api/library/physics/class.bodycloth'},
    {'id': 'bodydummy', 'path': '/api/library/physics/class.bodydummy'},
    {'id': 'bodyfracture', 'path': '/api/library/physics/class.bodyfracture'},
    {'id': 'bodyparticles', 'path': '/api/library/physics/class.bodyparticles'},
    {'id': 'bodypath', 'path': '/api/library/physics/class.bodypath'},
    {'id': 'bodyragdoll', 'path': '/api/library/physics/class.bodyragdoll'},
    {'id': 'bodyrigid', 'path': '/api/library/physics/class.bodyrigid'},
    {'id': 'bodyrope', 'path': '/api/library/physics/class.bodyrope'},
    {'id': 'bodywater', 'path': '/api/library/physics/class.bodywater'},
    {'id': 'joint', 'path': '/api/library/physics/class.joint'},
    {'id': 'jointball', 'path': '/api/library/physics/class.jointball'},
    {'id': 'jointcylindrical',
    'path': '/api/library/physics/class.jointcylindrical'},
    {'id': 'jointfixed', 'path': '/api/library/physics/class.jointfixed'},
    {'id': 'jointhinge', 'path': '/api/library/physics/class.jointhinge'},
    {'id': 'jointparticles', 'path': '/api/library/physics/class.jointparticles'},
    {'id': 'jointpath', 'path': '/api/library/physics/class.jointpath'},
    {'id': 'jointprismatic', 'path': '/api/library/physics/class.jointprismatic'},
    {'id': 'jointsuspension',
    'path': '/api/library/physics/class.jointsuspension'},
    {'id': 'jointwheel', 'path': '/api/library/physics/class.jointwheel'},
    {'id': 'physical', 'path': '/api/library/physics/class.physical'},
    {'id': 'physicalforce', 'path': '/api/library/physics/class.physicalforce'},
    {'id': 'physicaltrigger',
    'path': '/api/library/physics/class.physicaltrigger'},
    {'id': 'physicalnoise', 'path': '/api/library/physics/class.physicalnoise'},
    {'id': 'physicalwater', 'path': '/api/library/physics/class.physicalwater'},
    {'id': 'physicalwind', 'path': '/api/library/physics/class.physicalwind'},
    {'id': 'shape', 'path': '/api/library/physics/class.shape'},
    {'id': 'shapebox', 'path': '/api/library/physics/class.shapebox'},
    {'id': 'shapecapsule', 'path': '/api/library/physics/class.shapecapsule'},
    {'id': 'shapeconvex', 'path': '/api/library/physics/class.shapeconvex'},
    {'id': 'shapecylinder', 'path': '/api/library/physics/class.shapecylinder'},
    {'id': 'shapesphere', 'path': '/api/library/physics/class.shapesphere'},
    {'id': 'gpumonitor',
    'path': '/api/library/plugins/gpumonitor/class.gpumonitor'},
    {'id': 'gpumonitorplugin',
    'path': '/api/library/plugins/gpumonitor/class.gpumonitorplugin'},
    {'id': 'autodeskimport', 'path': '/api/library/plugins/autodeskimport.class'},
    {'id': 'appeasyblend', 'path': '/api/library/plugins/appeasyblend.class'},
    {'id': 'colladaimport', 'path': '/api/library/plugins/colladaimport.class'},
    {'id': 'openflightimport',
    'path': '/api/library/plugins/openflightimport.class'},
    {'id': 'engine_grabber', 'path': '/api/library/plugins/engine.grabber'},
    {'id': 'kinect', 'path': '/api/library/plugins/engine.kinect'},
    {'id': 'appoculus', 'path': '/api/library/plugins/engine.oculus'},
    {'id': 'appprojection',
    'path': '/api/library/plugins/class.appprojectioninterface'},
    {'id': 'engine_surround', 'path': '/api/library/plugins/engine.surround'},
    {'id': 'appvarjo', 'path': '/api/library/plugins/class.appvarjo'},
    {'id': 'appvive', 'path': '/api/library/plugins/engine.vive'},
    {'id': 'appwall', 'path': '/api/library/plugins/engine.wall'},
    {'id': 'arttracker', 'path': '/api/library/plugins/class.arttracker'},
    {'id': 'cigiaerosolresponse',
    'path': '/api/library/plugins/ig/cigi/class.icigiaerosolresponse'},
    {'id': 'cigianimationnotify',
    'path': '/api/library/plugins/ig/cigi/class.icigianimationnotify'},
    {'id': 'cigiarticulatedcontrol',
    'path': '/api/library/plugins/ig/cigi/class.icigiarticulatedcontrol'},
    {'id': 'cigiarticulatedshortcontrol',
    'path': '/api/library/plugins/ig/cigi/class.icigiarticulatedshortcontrol'},
    {'id': 'cigiatmospherecontrol',
    'path': '/api/library/plugins/ig/cigi/class.icigiatmospherecontrol'},
    {'id': 'cigicelestialcontrol',
    'path': '/api/library/plugins/ig/cigi/class.icigicelestialcontrol'},
    {'id': 'cigicomponentcontrol',
    'path': '/api/library/plugins/ig/cigi/class.icigicomponentcontrol'},
    {'id': 'cigicomponentshortcontrol',
    'path': '/api/library/plugins/ig/cigi/class.icigicomponentshortcontrol'},
    {'id': 'cigiearthmodeldef',
    'path': '/api/library/plugins/ig/cigi/class.icigiearthmodeldef'},
    {'id': 'cigientityclampedcontrol',
    'path': '/api/library/plugins/ig/cigi/class.icigientityclampedcontrol'},
    {'id': 'cigientitycontrol',
    'path': '/api/library/plugins/ig/cigi/class.icigientitycontrol'},
    {'id': 'cigienvironmentcontrol',
    'path': '/api/library/plugins/ig/cigi/class.icigienvironmentcontrol'},
    {'id': 'cigienvironmentpolygoncontrol',
    'path': '/api/library/plugins/ig/cigi/class.cigienvironmentpolygoncontrol'},
    {'id': 'cigienvironmentrequest',
    'path': '/api/library/plugins/ig/cigi/class.icigienvironmentrequest'},
    {'id': 'cigieventnotify',
    'path': '/api/library/plugins/ig/cigi/class.icigieventnotify'},
    {'id': 'cigihathotextresponse',
    'path': '/api/library/plugins/ig/cigi/class.icigihathotextresponse'},
    {'id': 'cigihathotrequest',
    'path': '/api/library/plugins/ig/cigi/class.icigihathotrequest'},
    {'id': 'cigihathotresponse',
    'path': '/api/library/plugins/ig/cigi/class.icigihathotresponse'},
    {'id': 'cigihostpacket',
    'path': '/api/library/plugins/ig/cigi/class.icigihostpacket'},
    {'id': 'cigihostuserdefined',
    'path': '/api/library/plugins/ig/cigi/class.icigihostuserdefined'},
    {'id': 'cigiigcontrol',
    'path': '/api/library/plugins/ig/cigi/class.icigiigcontrol'},
    {'id': 'cigiigmessage',
    'path': '/api/library/plugins/ig/cigi/class.icigiigmessage'},
    {'id': 'cigiigpacket',
    'path': '/api/library/plugins/ig/cigi/class.icigiigpacket'},
    {'id': 'cigiiguserdefined',
    'path': '/api/library/plugins/ig/cigi/class.icigiiguserdefined'},
    {'id': 'cigilosextresponse',
    'path': '/api/library/plugins/ig/cigi/class.icigilosextresponse'},
    {'id': 'cigilosresponse',
    'path': '/api/library/plugins/ig/cigi/class.icigilosresponse'},
    {'id': 'cigilossegmentrequest',
    'path': '/api/library/plugins/ig/cigi/class.icigilossegmentrequest'},
    {'id': 'cigilosvectorrequest',
    'path': '/api/library/plugins/ig/cigi/class.icigilosvectorrequest'},
    {'id': 'cigimaritimecontrol',
    'path': '/api/library/plugins/ig/cigi/class.icigimaritimecontrol'},
    {'id': 'cigimaritimeresponse',
    'path': '/api/library/plugins/ig/cigi/class.icigimaritimeresponse'},
    {'id': 'cigipositionrequest',
    'path': '/api/library/plugins/ig/cigi/class.icigipositionrequest'},
    {'id': 'cigipositionresponse',
    'path': '/api/library/plugins/ig/cigi/class.icigipositionresponse'},
    {'id': 'cigiratecontrol',
    'path': '/api/library/plugins/ig/cigi/class.icigiratecontrol'},
    {'id': 'cigisegmentdef',
    'path': '/api/library/plugins/ig/cigi/class.icigisegmentdef'},
    {'id': 'cigisegmentnotify',
    'path': '/api/library/plugins/ig/cigi/class.icigisegmentnotify'},
    {'id': 'cigisensorcontrol',
    'path': '/api/library/plugins/ig/cigi/class.icigisensorcontrol'},
    {'id': 'cigisensorextresponse',
    'path': '/api/library/plugins/ig/cigi/class.icigisensorextresponse'},
    {'id': 'cigisensorresponse',
    'path': '/api/library/plugins/ig/cigi/class.icigisensorresponse'},
    {'id': 'cigistartofframe',
    'path': '/api/library/plugins/ig/cigi/class.icigistartofframe'},
    {'id': 'cigisymbolcircledef',
    'path': '/api/library/plugins/ig/cigi/class.icigisymbolcircledef'},
    {'id': 'cigisymbolclone',
    'path': '/api/library/plugins/ig/cigi/class.icigisymbolclone'},
    {'id': 'cigisymbolcontrol',
    'path': '/api/library/plugins/ig/cigi/class.icigisymbolcontrol'},
    {'id': 'cigisymbollinedef',
    'path': '/api/library/plugins/ig/cigi/class.icigisymbollinedef'},
    {'id': 'cigisymbolshortcontrol',
    'path': '/api/library/plugins/ig/cigi/class.icigisymbolshortcontrol'},
    {'id': 'cigisymbolsurfacedef',
    'path': '/api/library/plugins/ig/cigi/class.icigisymbolsurfacedef'},
    {'id': 'cigisymboltextdef',
    'path': '/api/library/plugins/ig/cigi/class.icigisymboltextdef'},
    {'id': 'cigiterrestrialcontrol',
    'path': '/api/library/plugins/ig/cigi/class.icigiterrestrialcontrol'},
    {'id': 'cigiterrestrialresponse',
    'path': '/api/library/plugins/ig/cigi/class.icigiterrestrialresponse'},
    {'id': 'cigitrackercontrol',
    'path': '/api/library/plugins/ig/cigi/class.icigitrackercontrol'},
    {'id': 'cigitrajectorydef',
    'path': '/api/library/plugins/ig/cigi/class.icigitrajectorydef'},
    {'id': 'cigiviewcontrol',
    'path': '/api/library/plugins/ig/cigi/class.icigiviewcontrol'},
    {'id': 'cigiviewdef',
    'path': '/api/library/plugins/ig/cigi/class.icigiviewdef'},
    {'id': 'cigivolumedef',
    'path': '/api/library/plugins/ig/cigi/class.icigivolumedef'},
    {'id': 'cigivolumenotify',
    'path': '/api/library/plugins/ig/cigi/class.icigivolumenotify'},
    {'id': 'cigiwavecontrol',
    'path': '/api/library/plugins/ig/cigi/class.icigiwavecontrol'},
    {'id': 'cigiweathercontrol',
    'path': '/api/library/plugins/ig/cigi/class.icigiweathercontrol'},
    {'id': 'cigiweatherresponse',
    'path': '/api/library/plugins/ig/cigi/class.icigiweatherresponse'},
    {'id': 'ig_manager',
    'path': '/api/library/plugins/ig/api/class.managerinterface'},
    {'id': 'igconfig', 'path': '/api/library/plugins/ig/api/class.igconfig'},
    {'id': 'ig_component', 'path': '/api/library/plugins/ig/api/class.component'},
    {'id': 'ig_componentbaseinterface',
    'path': '/api/library/plugins/ig/api/class.componentbaseinterface'},
    {'id': 'articulatedpart',
    'path': '/api/library/plugins/ig/api/class.articulatedpart'},
    {'id': 'collisionsegment',
    'path': '/api/library/plugins/ig/api/class.collisionsegment'},
    {'id': 'collisionvolume',
    'path': '/api/library/plugins/ig/api/class.collisionvolume'},
    {'id': 'converter', 'path': '/api/library/plugins/ig/api/class.converter'},
    {'id': 'entity', 'path': '/api/library/plugins/ig/api/class.entity'},
    {'id': 'lightcontroller',
    'path': '/api/library/plugins/ig/api/class.lightcontroller'},
    {'id': 'meteo', 'path': '/api/library/plugins/ig/api/class.meteo'},
    {'id': 'meteocameraeffects',
    'path': '/api/library/plugins/ig/api/class.meteocameraeffects'},
    {'id': 'region', 'path': '/api/library/plugins/ig/api/class.region'},
    {'id': 'skymap', 'path': '/api/library/plugins/ig/api/class.skymap'},
    {'id': 'symbolscontroller',
    'path': '/api/library/plugins/ig/api/class.symbolscontroller'},
    {'id': 'symbolsplane',
    'path': '/api/library/plugins/ig/api/class.symbolsplane'},
    {'id': 'symbol', 'path': '/api/library/plugins/ig/api/class.symbol'},
    {'id': 'symbolpolyline',
    'path': '/api/library/plugins/ig/api/class.symbolpolyline'},
    {'id': 'symbolcircle',
    'path': '/api/library/plugins/ig/api/class.symbolcircle'},
    {'id': 'symboltext', 'path': '/api/library/plugins/ig/api/class.symboltext'},
    {'id': 'viewbase', 'path': '/api/library/plugins/ig/api/class.viewbase'},
    {'id': 'viewgroup', 'path': '/api/library/plugins/ig/api/class.viewgroup'},
    {'id': 'view', 'path': '/api/library/plugins/ig/api/class.view'},
    {'id': 'water', 'path': '/api/library/plugins/ig/api/class.water'},
    {'id': 'weatherlayer',
    'path': '/api/library/plugins/ig/api/class.weatherlayer'},
    {'id': 'weatherlayercloud',
    'path': '/api/library/plugins/ig/api/class.weatherlayercloud'},
    {'id': 'weatherlayerprecipitation',
    'path': '/api/library/plugins/ig/api/class.weatherlayerprecipitation'},
    {'id': 'iarticulatedpart',
    'path': '/api/library/plugins/cigiclient/api/iarticulatedpart_class'},
    {'id': 'icomponent',
    'path': '/api/library/plugins/cigiclient/api/icomponent_class'},
    {'id': 'entity', 'path': '/api/library/plugins/cigiclient/api/ientity_class'},
    {'id': 'iviewbase',
    'path': '/api/library/plugins/cigiclient/api/iviewbase_class'},
    {'id': 'view', 'path': '/api/library/plugins/cigiclient/api/iview_class'},
    {'id': 'viewgroup',
    'path': '/api/library/plugins/cigiclient/api/iviewgroup_class'},
    {'id': 'icigihostpacket',
    'path': '/api/library/plugins/cigiclient/api/icigihostpacket_class'},
    {'id': 'icigiarticulatedcontrol',
    'path': '/api/library/plugins/cigiclient/api/icigiarticulatedcontrol_class'},
    {'id': 'icigiarticulatedshortcontrol',
    'path': '/api/library/plugins/cigiclient/api/icigiarticulatedshortcontrol_class'},
    {'id': 'icigiatmospherecontrol',
    'path': '/api/library/plugins/cigiclient/api/icigiatmospherecontrol_class'},
    {'id': 'icigicelestialcontrol',
    'path': '/api/library/plugins/cigiclient/api/icigicelestialcontrol_class'},
    {'id': 'icigicomponentcontrol',
    'path': '/api/library/plugins/cigiclient/api/icigicomponentcontrol_class'},
    {'id': 'icigicomponentshortcontrol',
    'path': '/api/library/plugins/cigiclient/api/icigicomponentshortcontrol_class'},
    {'id': 'icigientitycontrol',
    'path': '/api/library/plugins/cigiclient/api/icigientitycontrol_class'},
    {'id': 'icigientityclampedcontrol',
    'path': '/api/library/plugins/cigiclient/api/icigientityclampedcontrol_class'},
    {'id': 'icigienvironmentcontrol',
    'path': '/api/library/plugins/cigiclient/api/icigienvironmentcontrol_class'},
    {'id': 'icigienvironmentrequest',
    'path': '/api/library/plugins/cigiclient/api/icigienvironmentrequest_class'},
    {'id': 'icigiigcontrol',
    'path': '/api/library/plugins/cigiclient/api/icigiigcontrol_class'},
    {'id': 'icigimaritimecontrol',
    'path': '/api/library/plugins/cigiclient/api/icigimaritimecontrol_class'},
    {'id': 'icigiratecontrol',
    'path': '/api/library/plugins/cigiclient/api/icigiratecontrol_class'},
    {'id': 'icigisensorcontrol',
    'path': '/api/library/plugins/cigiclient/api/icigisensorcontrol_class'},
    {'id': 'icigisymbolcircledef',
    'path': '/api/library/plugins/cigiclient/api/icigisymbolcircledef_class'},
    {'id': 'icigisymbolclone',
    'path': '/api/library/plugins/cigiclient/api/icigisymbolclone_class'},
    {'id': 'icigisymbolcontrol',
    'path': '/api/library/plugins/cigiclient/api/icigisymbolcontrol_class'},
    {'id': 'icigisymbolshortcontrol',
    'path': '/api/library/plugins/cigiclient/api/icigisymbolshortcontrol_class'},
    {'id': 'icigisymbollinedef',
    'path': '/api/library/plugins/cigiclient/api/icigisymbollinedef_class'},
    {'id': 'icigisymbolsurfacedef',
    'path': '/api/library/plugins/cigiclient/api/icigisymbolsurfacedef_class'},
    {'id': 'icigisymboltextdef',
    'path': '/api/library/plugins/cigiclient/api/icigisymboltextdef_class'},
    {'id': 'icigiterrestrialcontrol',
    'path': '/api/library/plugins/cigiclient/api/icigiterrestrialcontrol_class'},
    {'id': 'icigitrackercontrol',
    'path': '/api/library/plugins/cigiclient/api/icigitrackercontrol_class'},
    {'id': 'icigiviewcontrol',
    'path': '/api/library/plugins/cigiclient/api/icigiviewcontrol_class'},
    {'id': 'icigiwavecontrol',
    'path': '/api/library/plugins/cigiclient/api/icigiwavecontrol_class'},
    {'id': 'icigiweathercontrol',
    'path': '/api/library/plugins/cigiclient/api/icigiweathercontrol_class'},
    {'id': 'icigiviewdef',
    'path': '/api/library/plugins/cigiclient/api/icigiviewdef_class'},
    {'id': 'icigiearthmodeldef',
    'path': '/api/library/plugins/cigiclient/api/icigiearthmodeldef_class'},
    {'id': 'icigisegmentdef',
    'path': '/api/library/plugins/cigiclient/api/icigisegmentdef_class'},
    {'id': 'icigitrajectorydef',
    'path': '/api/library/plugins/cigiclient/api/icigitrajectorydef_class'},
    {'id': 'icigivolumedef',
    'path': '/api/library/plugins/cigiclient/api/icigivolumedef_class'},
    {'id': 'icigihathotrequest',
    'path': '/api/library/plugins/cigiclient/api/icigihathotrequest_class'},
    {'id': 'icigiigpacket',
    'path': '/api/library/plugins/cigiclient/api/icigiigpacket_class'},
    {'id': 'icigistartofframe',
    'path': '/api/library/plugins/cigiclient/api/icigistartofframe_class'},
    {'id': 'icigiaerosolresponse',
    'path': '/api/library/plugins/cigiclient/api/icigiaerosolresponse_class'},
    {'id': 'icigihathotresponse',
    'path': '/api/library/plugins/cigiclient/api/icigihathotresponse_class'},
    {'id': 'icigihathotextresponse',
    'path': '/api/library/plugins/cigiclient/api/icigihathotextresponse_class'},
    {'id': 'icigilosresponse',
    'path': '/api/library/plugins/cigiclient/api/icigilosresponse_class'},
    {'id': 'icigilosextresponse',
    'path': '/api/library/plugins/cigiclient/api/icigilosextresponse_class'},
    {'id': 'icigilossegmentrequest',
    'path': '/api/library/plugins/cigiclient/api/icigilossegmentrequest_class'},
    {'id': 'icigilosvectorrequest',
    'path': '/api/library/plugins/cigiclient/api/icigilosvectorrequest_class'},
    {'id': 'icigimaritimeresponse',
    'path': '/api/library/plugins/cigiclient/api/icigimaritimeresponse_class'},
    {'id': 'icigipositionrequest',
    'path': '/api/library/plugins/cigiclient/api/icigipositionrequest_class'},
    {'id': 'icigipositionresponse',
    'path': '/api/library/plugins/cigiclient/api/icigipositionresponse_class'},
    {'id': 'icigisensorresponse',
    'path': '/api/library/plugins/cigiclient/api/icigisensorresponse_class'},
    {'id': 'icigisensorextresponse',
    'path': '/api/library/plugins/cigiclient/api/icigisensorextresponse_class'},
    {'id': 'icigiterrestrialresponse',
    'path': '/api/library/plugins/cigiclient/api/icigiterrestrialresponse_class'},
    {'id': 'icigiweatherresponse',
    'path': '/api/library/plugins/cigiclient/api/icigiweatherresponse_class'},
    {'id': 'interfacewindow',
    'path': '/api/library/plugins/interface/class.interfacewindow'},
    {'id': 'interface',
    'path': '/api/library/plugins/interface/engine.interface'},
    {'id': 'bank', 'path': '/api/library/plugins/fmod/class.bank'},
    {'id': 'bus', 'path': '/api/library/plugins/fmod/class.bus'},
    {'id': 'channel', 'path': '/api/library/plugins/fmod/class.channel'},
    {'id': 'channelcontrol',
    'path': '/api/library/plugins/fmod/class.channelcontrol'},
    {'id': 'channelgroup',
    'path': '/api/library/plugins/fmod/class.channelgroup'},
    {'id': 'dsp', 'path': '/api/library/plugins/fmod/class.dsp'},
    {'id': 'dsptype', 'path': '/api/library/plugins/fmod/class.dsptype'},
    {'id': 'eventdescription',
    'path': '/api/library/plugins/fmod/class.eventdescription'},
    {'id': 'eventinstance',
    'path': '/api/library/plugins/fmod/class.eventinstance'},
    {'id': 'fmod', 'path': '/api/library/plugins/fmod/class.fmod'},
    {'id': 'fmodcore', 'path': '/api/library/plugins/fmod/class.fmodcore'},
    {'id': 'fmodenums', 'path': '/api/library/plugins/fmod/class.fmodenums'},
    {'id': 'fmodstudio', 'path': '/api/library/plugins/fmod/class.fmodstudio'},
    {'id': 'reverb3d', 'path': '/api/library/plugins/fmod/class.reverb3d'},
    {'id': 'soundgroup', 'path': '/api/library/plugins/fmod/class.soundgroup'},
    {'id': 'fmod_sound', 'path': '/api/library/plugins/fmod/class.sound'},
    {'id': 'vca', 'path': '/api/library/plugins/fmod/class.vca'},
    {'id': 'leapmotion',
    'path': '/api/library/plugins/leapmotion/class.leapmotioninterface'},
    {'id': 'leapmotion_arm',
    'path': '/api/library/plugins/leapmotion/class.leapmotionarm'},
    {'id': 'leapmotion_bone',
    'path': '/api/library/plugins/leapmotion/class.leapmotionbone'},
    {'id': 'leapmotion_finger',
    'path': '/api/library/plugins/leapmotion/class.leapmotionfinger'},
    {'id': 'leapmotion_hand',
    'path': '/api/library/plugins/leapmotion/class.leapmotionhand'},
    {'id': 'sslsocket', 'path': '/api/library/plugins/sslsocket/class.sslsocket'},
    {'id': 'sslsocketplugin',
    'path': '/api/library/plugins/sslsocket/class.sslsocketplugin'},
    {'id': 'steam', 'path': '/api/library/plugins/steam/class.steam'},
    {'id': 'steamleaderboard',
    'path': '/api/library/plugins/steam/class.steamleaderboard'},
    {'id': 'manager',
    'path': '/api/library/plugins/syncker/class.managerinterface'},
    {'id': 'syncker',
    'path': '/api/library/plugins/syncker/class.synckerinterface'},
    {'id': 'master',
    'path': '/api/library/plugins/syncker/class.masterinterface'},
    {'id': 'slave', 'path': '/api/library/plugins/syncker/class.slaveinterface'},
    {'id': 'projections',
    'path': '/api/library/plugins/syncker/class.projections'},
    {'id': 'teslasuitgeneral',
    'path': '/api/library/plugins/teslasuit/class.teslasuitgeneral'},
    {'id': 'suit', 'path': '/api/library/plugins/teslasuit/class.suit'},
    {'id': 'suitmanager',
    'path': '/api/library/plugins/teslasuit/class.suitmanager'},
    {'id': 'vrpnclient', 'path': '/api/library/plugins/vrpn/class.vrpnclient'},
    {'id': 'vrpnanalogdevice',
    'path': '/api/library/plugins/vrpn/vrpnanalogdevice.class'},
    {'id': 'vrpnbuttondevice',
    'path': '/api/library/plugins/vrpn/vrpnbuttondevice.class'},
    {'id': 'vrpntrackerdevice',
    'path': '/api/library/plugins/vrpn/vrpntrackerdevice.class'},
    {'id': 'camera', 'path': '/api/library/rendering/class.camera'},
    {'id': 'engineexpression', 'path': '/api/library/rendering/class.expression'},
    {'id': 'ffp', 'path': '/api/library/rendering/class.ffp'},
    {'id': 'material', 'path': '/api/library/rendering/class.material'},
    {'id': 'materials', 'path': '/api/library/rendering/class.materials'},
    {'id': 'mesh', 'path': '/api/library/rendering/class.mesh'},
    {'id': 'meshdynamic', 'path': '/api/library/rendering/class.meshdynamic'},
    {'id': 'meshstatic', 'path': '/api/library/rendering/class.meshstatic'},
    {'id': 'primitives', 'path': '/api/library/rendering/class.primitives'},
    {'id': 'render', 'path': '/api/library/rendering/class.render'},
    {'id': 'renderenvironmentpreset',
    'path': '/api/library/rendering/class.renderenvironmentpreset'},
    {'id': 'renderer', 'path': '/api/library/rendering/class.renderer'},
    {'id': 'rendercontext', 'path': '/api/library/rendering/class.rendercontext'},
    {'id': 'renderstate', 'path': '/api/library/rendering/class.renderstate'},
    {'id': 'rendertarget', 'path': '/api/library/rendering/class.rendertarget'},
    {'id': 'shader', 'path': '/api/library/rendering/class.shader'},
    {'id': 'cpushader', 'path': '/api/library/rendering/class.cpushader'},
    {'id': 'structuredbuffer',
    'path': '/api/library/rendering/class.structuredbuffer'},
    {'id': 'texture', 'path': '/api/library/rendering/class.texture'},
    {'id': 'texturecurve', 'path': '/api/library/rendering/class.texturecurve'},
    {'id': 'viewport', 'path': '/api/library/rendering/class.viewport'}]